import Guid from 'guid'
import queryString from 'query-string'
import moment from 'moment'
import 'moment/locale/de';
import momenttimezone from 'moment-timezone'
import { ConstPaths }from '@/config/pathConfig'
import { Get, Post } from '@/modules/wrapper/apiWrapper'
import { isPhoneGap, isInIframe } from '@/modules/util/util'
import DeviceInfo from '@/modules/util/deviceInfo'
import {loadWebsite, loadInstagram, loadFacebook, loadYoutubeData} from  '@/modules/wrapper/dataProviderWrapper'

export const IsUserActionAllow = () => {
  if (isInIframe()) {
    return false
  } else {
    return true
  }
}

// let storeGetters = store.getters
//   if (storeGetters.SidePanelActive) {
//     storeGetters.panelValue.close()
//   }

export const IsAccessLockedTrue = async (getters, Id) => {
  let moduleInfo =  await Get(`AppConfigSync/checkAccessLocked/`+ Id).then(response => response)
  return moduleInfo
}

export const IsDevSim = () => {
  const params = queryString.parse(location.search)
  if (params.devsim === 'true') {
    return true
  } else {
    return false
  }
}

export const IsScreenCapture = () => {
  const params = queryString.parse(location.search)
  if (params.screencapture === 'true') {
    return true
  } else {
    return false
  }
}

export const IsUndefined = (value) => {
  var notDefinedVar
  return (typeof value === typeof notDefinedVar)
}

export const IsValid = (value, withLengthCheck) => {
  var notDefinedVar
  if (IsUndefined(withLengthCheck) || withLengthCheck === null || withLengthCheck === false) {
    return (typeof value !== typeof notDefinedVar && value !== null)
  } else {
    return (typeof value !== typeof notDefinedVar && value !== null && value.length !== 0)
  }
}

export const IsNullOrEmpty = (value) => {
  let flage = false
  if (IsUndefined(value) || value === null || value === 'null' || value.trim() === '') {
    flage = true
  }
  return flage
}

export const getRandomInt = () => {
  let min = Math.ceil(1);
  let max = Math.floor(1000);
  return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
}

export const validateEmail = (email) => {
  return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)
}

export const validatePhone = (phone) => {
  return /^[+]?([0-9]*[\.\s\-\(\)]|[0-9]+){3,24}$/.test(phone)
//  return /^\d{0,9}(\.\d{0,2})?$/.test(phone)
}

export const validateUrl = (url) => {
  return /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/.test(url)
}

export const ReplaceBackslashNtoBr = (value) => {
  return value.replace(/\n/g, '<br>')
}

export const getMonthNames = () => {
  let months = []
  let date = CurrentDateTime()
  for (var i = 0; i < 12; i++)
    months.push(date.month(i).format('MMMM'))
  return months
}

export const getMonthDays = () => {
  return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
}

export const getYears = () => {
  var arr = []
  let date = CurrentDateTime()
  let curyear = date.format('YYYY')
  let minY = parseInt(curyear) - 100
  let maxY = parseInt(curyear) + 100
  for (var i = minY; i <= maxY; i++) { arr.push(i) }
  return arr
}

export const getCurrentTime = () => {
  let date = CurrentDateTime()
  let time = date.format('HH:mm')
  return time
}

export const FormatDate = (value ,formatString, strUhr) => {
  let timezone = moment(value)
  //console.log('in date formate', value)
  let ger = language.get() === 'de'
  switch (formatString) {
    case 'DD MMMM YYYY':
      return ger ? timezone.format('DD. MMMM YYYY') : timezone.format('DD MMMM YYYY')
      break;
    case 'DD MMM YYYY':
      return ger ? timezone.format('DD. MMM YYYY') : timezone.format('DD MMM YYYY')
      break;
    case 'DD MMM':
      return ger ? timezone.format('DD. MMM') : timezone.format('DD MMM')
      break;
    case 'DD':
      return timezone.format('DD')
      break;
    case 'MMMM':
      return timezone.format('MMMM')
      break;
    case 'MMM':
        return timezone.format('MMM')
      break;
    case 'YYYY':
        return timezone.format('YYYY')
      break;
    case 'DD MMMM YYYY HH:mm':
        return ger ? timezone.format('DD. MMMM YYYY HH:mm') + strUhr : timezone.format('DD MMMM YYYY HH:mm')
      break;
      case 'facebookTime-sameYear':
        return ger ? 'Am '+ timezone.format('D. MMM') +' um '+ timezone.format('h:mm A')  : timezone.format('D MMM  h:mm A')
      break;
      case 'facebookTime-withYear':
        return ger ? 'Am '+ timezone.format('D. MMM YYYY') +' um '+ timezone.format('h:mm A')  : timezone.format('D MMM YYYY')+' at '+timezone.format('h:mm A')
      break;
    default:
      return ger ? timezone.format('DD[.] MMMM YYYY') : timezone.format('DD MMMM YYYY')
  }

}
export const EventFormatDate = (value ,formatString, strUhr) => {
  let timezone = moment(value)
  let ger = language.get() === 'de'
  switch (formatString) {
    case 'DD MMMM YYYY':
      return ger ? timezone.format('DD. MMMM YYYY') : timezone.format('DD MMMM YYYY')
      break;
    case 'DD MMM YYYY':
      return ger ? timezone.format('DD. MMM YYYY') : timezone.format('DD MMM YYYY')
      break;
    case 'DD MMM':
      return ger ? timezone.format('DD. MMM') : timezone.format('DD MMM')
      break;
    case 'DD':
      return timezone.format('DD')
      break;
    case 'MMMM':
      return timezone.format('MMMM')
      break;
    case 'MMM':
        return timezone.format('MMM')
      break;
    case 'YYYY':
        return timezone.format('YYYY')
      break;
    case 'DD MMMM YYYY HH:mm':
        return ger ? timezone.format('DD. MMMM YYYY HH:mm') + strUhr : timezone.format('DD MMMM YYYY HH:mm')
      break;
      case 'facebookTime-sameYear':
        return ger ? 'Am '+ timezone.format('D. MMM') +' um '+ timezone.format('h:mm A')  : timezone.format('D MMM  h:mm A')
      break;
      case 'facebookTime-withYear':
        return ger ? 'Am '+ timezone.format('D. MMM YYYY') +' um '+ timezone.format('h:mm A')  : timezone.format('D MMM YYYY')+' at '+timezone.format('h:mm A')
      break;
    default:
      return ger ? timezone.format('DD[.] MMMM YYYY') : timezone.format('DD MMMM YYYY')
  }

}

export const FormattedDateDDMMMMYY = (value) => {
  return FormatDate(value, 'DD MMMM YYYY')
}
export const FormattedDateDDMMMMYYHHMM = (value, strUhr) => {
  return FormatDate(value, 'DD MMMM YYYY HH:mm', strUhr)
}

export const getDateDay = (value) => {
  return FormatDate(value, 'DD')
}
export const getDateMonth = (value) => {
  return FormatDate(value, 'MMM')
}
export const getMonthOnly = (value) => {
  return FormatDate(value, 'MMMM')
}
export const ConvertToMyZone = (value) => {
  if (IsValid(value, true)) {
    moment.locale(language.get())
    let dbtimezone = moment.tz(value, 'Europe/Amsterdam')
    let localtimezone = dbtimezone.tz(moment.tz.guess())
    return localtimezone
  } else {
    moment.locale(language.get())
    let timezone = moment.tz.guess()
    return moment().tz(timezone)
  }
}
export const ConvertToMyZoneUtc = (value) => {
  if (IsValid(value, true)) {
    let utcd = moment.utc(value).format('YYYY-MM-DD HH:mm:ss')
    let localTime = moment.utc(utcd).toDate()
    let tzDate = moment(localTime)
    tzDate.locale(language.get())
    let dbtimezone = moment.tz(tzDate, 'Europe/Amsterdam')
    let localtimezone = dbtimezone.tz(moment.tz.guess())
    return localtimezone
  } else {
    moment.locale(language.get())
    let timezone = moment.tz.guess()
    return moment().tz(timezone)
  }
}


export const timeAgoFromNow = (value) => {
  if (value !== '') {
   // let tzDate = ConvertToMyZone(value)
    let utcd = moment.utc(value).format('YYYY-MM-DD HH:mm:ss')
    let localTime = moment.utc(utcd).toDate()
    let tzDate = moment(localTime)
    tzDate.locale(language.get())
    return tzDate.fromNow()
  } else {
    return ''
  }
}
export const CurrentDateTime = () => {
  return ConvertToMyZone()
}

export const ConvertToUnixDateTime = (value) => {
  if (IsValid(value, true)) {
    moment.locale(language.get())
    let dbtimezone = moment.tz(value, 'Europe/Amsterdam')
    return dbtimezone.unix()
  } else {
    moment.locale(language.get())
    let timezone = moment.tz.guess()
    return moment().tz(timezone).unix()
  }
}
export const CheckDateIsFutureDate = (eventObject) => {
  let sdate = (eventObject.EventStartDate)
  let edate = (eventObject.EventEndDate)
  let stime = (eventObject.EventStartTime)
  let etime = (eventObject.EventEndTime)
  let flage = false
  // eslint-disable-next-line
  let tag = null
  let filteredEvent = false
  let currentDateTime = moment()
  switch (true) {
    case IsValid(sdate, true) && IsValid(edate, true) && !IsValid(stime, true) && !IsValid(etime, true):
      flage = currentDateTime.isSameOrBefore(moment(sdate), 'day') || currentDateTime.isBefore(moment(edate).endOf('day'), 'minute', '[]')
      tag = flage ? 'SameOrBefore' : 'Past'
      break
    case IsValid(sdate, true) && IsValid(stime, true) && !IsValid(edate, true) && IsValid(etime, true) :
      tag = FilterEventStartEndDate(sdate, stime, etime)
      filteredEvent = true
      break
    case IsValid(sdate, true) && IsValid(stime, true) && !IsValid(edate, true) && !IsValid(etime, true) :
      flage = currentDateTime.isSameOrBefore(moment(`${sdate.substring(0, 10)}T${stime}`), 'minute')
      tag = flage ? 'SameOrBefore' : 'Past'
      break
    case IsValid(sdate, true) && !IsValid(stime, true) && !IsValid(etime, true) && !IsValid(edate, true):
      flage = currentDateTime.isSameOrBefore(moment(sdate).endOf('day'), 'minute', '[]')
      tag = flage ? 'SameOrBefore' : 'Past'
      break
    default:
      flage = false
      tag = 'Past'
  }
  if (tag !== 'Past' && !filteredEvent) {
    return CheckDateIsCurrentDate(eventObject)
  }
  eventObject.eventTag = tag
  return eventObject
}
export const FilterEventStartEndDate = (sdate, stime, etime) => {
  let currentDateTime = moment()
  // eslint-disable-next-line
  let tag = null
  // for same date
  let samedayDate = currentDateTime.isSame(moment(sdate), 'day')
  if (samedayDate) {
    let CurrentdayDate = currentDateTime.isBetween(moment(`${sdate.substring(0, 10)}T${stime}`), moment(`${sdate.substring(0, 10)}T${etime}`), 'minute', '[]')
    if (CurrentdayDate) {
      tag = 'Current'
      return tag
    }
    let sameDtFuturePast = currentDateTime.isAfter(moment(`${sdate.substring(0, 10)}T${stime}`), 'minute') && currentDateTime.isAfter(moment(`${sdate.substring(0, 10)}T${etime}`), 'minute')
    tag = sameDtFuturePast ? 'Past' : 'Future'
    return tag
  } else {
    let dateFuturePast = currentDateTime.isAfter(moment(sdate), 'day')
    tag = dateFuturePast ? tag = 'Past' : 'Future'
    return tag
  }
}
export const CheckDateIsCurrentDate = (eventObject) => {
  let sdate = (eventObject.EventStartDate)
  let edate = (eventObject.EventEndDate)
  let stime = (eventObject.EventStartTime)
  let etime = (eventObject.EventEndTime)
  let flage = false
  // eslint-disable-next-line
  let tag = null
  let currentDateTime = moment()
  switch (true) {
    case IsValid(sdate, true) && IsValid(edate, true) && !IsValid(stime, true) && !IsValid(etime, true):
      flage = currentDateTime.isBetween(moment(sdate), moment(edate), 'day', '[]')
      tag = flage ? 'Current' : 'Future'
      break
    case IsValid(sdate, true) && IsValid(stime, true) && !IsValid(etime, true):
      flage = currentDateTime.isBetween(moment(`${sdate.substring(0, 10)}T${stime}`), moment().endOf('day'), 'minute', '[]')
      tag = flage ? 'Current' : 'Future'
      break
    case IsValid(sdate, true) && !IsValid(stime, true) && !IsValid(etime, true) && !IsValid(edate, true):
      flage = currentDateTime.isSame(moment(sdate), 'day')
      tag = flage ? 'Current' : 'Future'
      break
    default:
      flage = false
      tag = 'Current'
  }
  eventObject.eventTag = tag
  return eventObject
}

export const IsMonthSame = (sdate, edate) => {
  if (ConvertToMyZone(sdate).format('M') === ConvertToMyZone(edate).format('M')) {
    return true
  } else {
    return false
  }
}
export const IsDaySame = (sdate, edate) => {
  if (ConvertToMyZone(sdate).format('D') === ConvertToMyZone(edate).format('D')) {
    return true
  } else {
    return false
  }
}
export const IsYearSame = (sdate, edate) => {
  if (ConvertToMyZone(sdate).format('YYYY') === ConvertToMyZone(edate).format('YYYY')) {
    return true
  } else {
    return false

  }
}
export const FormateTime = (value) => {
  if (IsValid(value, true)) {
    return moment(value, 'hh:mm:ss').format('HH:mm')
  } else {
    return moment().format('HH:mm')
  }
}

export const EventDateTime = (eventObject, strUhr) => {
  let sdate = (eventObject.EventStartDate)
  let edate = (eventObject.EventEndDate)
  let stime = (eventObject.EventStartTime)
  let etime = (eventObject.EventEndTime)
  let ShowDate = ''
  switch (true) {
    case IsValid(sdate, true) && IsValid(edate, true) && IsValid(stime, true) && IsValid(etime, true):
      switch (true) {
        case IsMonthSame(sdate, edate) && IsYearSame(sdate, edate):
          if (IsDaySame(sdate, edate)) {
            // ShowDate = ConvertToMyZone(sdate).format('LL') + ' | ' + FormateTime(stime) + '-' + FormateTime(etime) + strUhr
            ShowDate = EventFormatDate(sdate, 'DD MMMM YYYY') + ' | ' + FormateTime(stime) + ' - ' + FormateTime(etime) +  strUhr
          } else {
            ShowDate = EventFormatDate(sdate, 'DD') + ' - ' + EventFormatDate(edate, 'DD MMMM YYYY') + ' | ' + FormateTime(stime) + ' - ' + FormateTime(etime) + strUhr
          }
          break
        case !IsMonthSame(sdate, edate) && IsYearSame(sdate, edate):
          ShowDate = EventFormatDate(sdate, 'DD MMM') + '-' + EventFormatDate(edate, 'DD MMM YYYY') + ' | ' + FormateTime(stime) + ' - ' + FormateTime(etime) + strUhr
          break
        case !IsMonthSame(sdate, edate) && !IsYearSame(sdate, edate):
          ShowDate = EventFormatDate(sdate, 'DD MMMM YYYY') + ' - ' + EventFormatDate(edate, 'DD MMMM YYYY') + ' | ' + FormateTime(stime) + ' - ' + FormateTime(etime) + strUhr
          break
        default:
          ShowDate = EventFormatDate(sdate, 'DD MMMM YYYY') + ' - ' + EventFormatDate(edate, 'DD MMMM YYYY') + ' | ' + FormateTime(stime) + ' - ' + FormateTime(etime) + strUhr
      }
      break
    case IsValid(sdate, true) && IsValid(edate, true) && !IsValid(stime, true) && !IsValid(etime, true):
      switch (true) {
        case IsMonthSame(sdate, edate) && IsYearSame(sdate, edate):
          if (IsDaySame(sdate, edate)) {
            ShowDate = EventFormatDate(sdate, 'DD MMMM YYYY')
          } else {
            ShowDate = EventFormatDate(sdate, 'DD') + ' - ' + EventFormatDate(edate, 'DD MMMM YYYY')
          }
          break
        case !IsMonthSame(sdate, edate) && IsYearSame(sdate, edate):
          ShowDate = EventFormatDate(sdate, 'DD MMM') + '-' + EventFormatDate(edate, 'DD MMM YYYY')
          break
        case !IsMonthSame(sdate, edate) && !IsYearSame(sdate, edate):
          ShowDate = EventFormatDate(sdate, 'DD MMMM YYYY') + ' - ' + EventFormatDate(edate, 'DD MMMM YYYY')
          break
        default:
          ShowDate = EventFormatDate(sdate, 'DD MMMM YYYY') + ' - ' + EventFormatDate(edate, 'DD MMMM YYYY')
      }
      break
    case IsValid(sdate, true) && IsValid(stime, true) && IsValid(etime, true) && !IsValid(edate, true):
      ShowDate = EventFormatDate(sdate, 'DD MMMM YYYY') + ' | ' + FormateTime(stime) + ' - ' + FormateTime(etime) + strUhr
      break
    case IsValid(sdate, true) && IsValid(stime, true) && !IsValid(edate, true) && !IsValid(etime, true):
      ShowDate = EventFormatDate(sdate, 'DD MMMM YYYY') + ' | ' + FormateTime(stime) + strUhr
      break
    case IsValid(sdate, true) && !IsValid(stime, true) && !IsValid(edate, true) && !IsValid(etime, true):
      ShowDate = EventFormatDate(sdate, 'DD MMMM YYYY')
      break
    default:
      ShowDate = EventFormatDate(sdate, 'DD MMMM YYYY')
  }
  return ShowDate
}

export const GetAppGUID = (Subscription_Id) => {
  if (!IsValid(Subscription_Id, true)) {
    Subscription_Id = window.localStorage.getItem('Subscription_Id')
  }
  let appGuid = window.localStorage.getItem('AppGUID_' + Subscription_Id)
  if (IsValid(appGuid, true)) {
    window.localStorage.setItem('Subscription_Id', Subscription_Id)
    return appGuid
  } else {
    let guid = CreateGUID()
    window.localStorage.setItem('AppGUID_' + Subscription_Id, guid)
    window.localStorage.setItem('IsAlreadyRegistred_' + Subscription_Id, false)
    window.localStorage.setItem('Subscription_Id', Subscription_Id)
    return guid
  }
}

export const CreateGUID = () => {
  let guid = Guid.create()
  return guid.value
}

export const GetDeviceCountry = async(Subscription_Id) => {
  let IpObj= ''
  let countryObj = {
    ip: '',
    country_code: '',
    country:'',
    region: '',
    city: '',
    latitude: '',
    longitude: ''
  }
  await Get('IPDeviceInfo/GetIp').then(response => {
    IpObj = response
  })
  let response = await Get(`${ConstPaths.IpstackUrl + IpObj}?access_key=6cce930b2c2a298c4ce5aa72b749e038`).then(response => response)
  if (IsValid(response, true) && response.success !== false && IsValid(response.country_name, true) && IsValid(response.region_name, true) && IsValid(response.city, true)) {
    countryObj= {
      ip: IpObj,
      country_code: response.country_code,
      country:response.country_name,
      region: response.region_name,
      city: response.city,
      latitude: parseFloat(response.latitude),
      longitude: parseFloat(response.longitude)
    }
  } else {
    response = await Get(ConstPaths.IpApiUrl + IpObj).then(response => response)
    if (IsValid(response, true) && response.status !== 'fail' && IsValid(response.country, true) && IsValid(response.regionName, true) && IsValid(response.city, true)) {
       countryObj= {
         ip: IpObj,
         country_code: response.countryCode,
         country:response.country,
         region: response.regionName,
         city: response.city,
         latitude: parseFloat(response.lat),
         longitude: parseFloat(response.lon)
       }
     } else {
       response = await Get(ConstPaths.ExtremelookupUrl + IpObj).then(response => response)
       if (IsValid(response, true) && response.status !== 'fail' && IsValid(response.country, true) && IsValid(response.region, true) && IsValid(response.city, true)) {
         countryObj= {
           ip: IpObj,
           country_code: response.countryCode,
           country:response.country,
           region: response.region,
           city: response.city,
           latitude: parseFloat(response.lat),
           longitude: parseFloat(response.lon)
         }
       } else {
         response = await Get(ConstPaths.FreegeoiplookupUrl + IpObj).then(response => response)
         if (IsValid(response, true) && IsValid(response.country_name, true) && IsValid(response.region_name, true) && IsValid(response.city, true)) {
            countryObj= {
              ip: IpObj,
              country_code: response.country_code,
              country:response.country_name,
              region: response.region_name,
              city: response.city,
              latitude: parseFloat(response.latitude),
              longitude: parseFloat(response.longitude)
            }
          } else {
            countryObj= {
              ip: IpObj,
              country_code: 'N/A',
              country: 'N/A',
              region: 'N/A',
              city: 'N/A',
              latitude: parseFloat('0.000000'),
              longitude: parseFloat('0.000000')
            }
          }
       }
     }
  }
  // let response = await Get(ConstPaths.ExtremelookupUrl + IpObj).then(response => response)
  // if (IsValid(response, true)) {
  //   countryObj= {
  //     ip: response.query,
  //     country_code: response.countryCode,
  //     country:response.country,
  //     region: response.region,
  //     city: response.city,
  //     latitude: parseFloat(response.lat),
  //     longitude: parseFloat(response.lon)
  //   }
  // } else {
  //   response = await Get(ConstPaths.FreegeoiplookupUrl + IpObj).then(response => response)
  //   if (IsValid(response, true)) {
  //      countryObj= {
  //        ip: response.ip,
  //        country_code: response.country_code,
  //        country:response.country_name,
  //        region: response.region_name,
  //        city: response.city,
  //        latitude: parseFloat(response.latitude),
  //        longitude: parseFloat(response.longitude)
  //      }
  //    }
  // }
  return countryObj
}

const onShareSucess = (result) => {
  Keyboard.shrinkView(true)
  console.log('Share completed? ' + result.completed) // On Android apps mostly return false even while it s true
  console.log('Shared to app: ' + result.app) // On Android result.app is currently empty. On iOS it s empty when sharing is cancelled (result.completed=false)
}

const onShareError = (msg) => {
  Keyboard.shrinkView(true)
  console.log('Sharing failed with message: ' + msg)
}

export const CurrentWebAppLocation = (ContentBaseUrl, Subscription_GUID) => {
  let currentLocation = window.location.href.split('#!')
  let viewPath = currentLocation[1]
  return `${ContentBaseUrl}/${Subscription_GUID}/app/index.html#!${viewPath}`
}

export const CurrentlocationURL = () => {
  let currentLocation = window.location.href.split('#!')
  let viewPath = currentLocation[1].split('/')
  return viewPath[1]
}

export const InitShare = (payload) => {
  console.log('payload', payload)
  if(!IsValid(payload.moduleId)) {
    let module = payload.appConfig.Modules.Items.find(m => m.Id === payload.subscriptionModuleId)
    payload.moduleId = module.Module_Id
  }
  let metaDataUrl = `${payload.appConfig.Urls.WebAPIURL}/api/ShareFeed/${payload.appConfig.Subscription_Id}/${payload.moduleId}/${payload.subscriptionModuleId}/${payload.shareId}/${encodeURIComponent(payload.path)}/${payload.orderId}?dt=${ConvertToUnixDateTime()}`
  let options = {
    // message: payload.message, // not supported on some apps (Facebook, Instagram)
    // subject: payload.subject, // fi. for email
    // files: payload.files, // an array of filenames either locally or remotely
    url: metaDataUrl,
    chooserTitle: 'Pick an app' // Android only, you can override the default share sheet title
  }
  console.log('options', options)
  if (isPhoneGap()) {
    Keyboard.shrinkView(false)
    // this is the complete list of currently supported params you can pass to the plugin (all optional)
    window.plugins.socialsharing.shareWithOptions(options, onShareSucess, onShareError)
  } else {
    let mailToString = `mailto:?to=&subject=${payload.appConfig.AppName}&body=${metaDataUrl}`
    window.open(mailToString, 'emailWindow')
  }
}

export const InitFavorite = (childId, parentId) => {
  let myFavorite = window.localStorage.getItem('MyFavorite')
  if (IsValid(myFavorite, true)) {
    let favorites = JSON.parse(myFavorite)
    let isDeleted = false
    let deleteIndex
    favorites.findIndex((val, index) => {
      if (val.Reference_Id === childId &&
        val.ReferenceParent_Id === parentId) {
        isDeleted = true
        deleteIndex = index
      }
    })
    if (!isDeleted) {
      let fav = {
        Reference_Id: childId,
        ReferenceParent_Id: parentId
      }
      favorites.push(fav)
      window.localStorage.setItem('MyFavorite', JSON.stringify(favorites))
    } else {
      favorites.splice(deleteIndex, 1)
      window.localStorage.setItem('MyFavorite', JSON.stringify(favorites))
    }
  } else {
    let favorites = []
    let fav = {
      Reference_Id: childId,
      ReferenceParent_Id: parentId
    }
    favorites.push(fav)
    window.localStorage.setItem('MyFavorite', JSON.stringify(favorites))
  }
}

export const CheckIsFavorite = (childId, parentId) => {
  let isFavorite = false
  let myFavorite = window.localStorage.getItem('MyFavorite')
  if (IsValid(myFavorite, true)) {
    let favorites = JSON.parse(myFavorite)
    let favfind
    favfind = favorites.find(fav => fav.Reference_Id === childId)
    if (IsUndefined(favfind)) {
      isFavorite = false
    } else {
      isFavorite = true
    }
  }
  return isFavorite
}

export const HashCodeFromInt = value => {
  if (IsValid(value) && value.toString().indexOf('#') === -1) {
    value = value.toString(16)
    if (parseInt(value) === 0) {
      return '#000000'
    }
    while (value.toString().trim().length < 6) {
      value = '0' + value
    }
    value = '#' + value
  }
  return value
}

export const hexToRgb = hex => {
  if (!IsValid(hex)) {
    hex = '#000000'
  }
  return hex && hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b)
  .substring(1).match(/.{2}/g)
  .map(x => parseInt(x, 16)).join(',')
}

export const replaceRN = value => {
  if (IsValid(value)) {
    value = value.replace(/(?:\r\n|\r|\n)/g, ' ')
  }
  return value
}

export const convertBoolean = (value) => {
  let booleanValue = false
  booleanValue = ((typeof value === 'string' && value === 'true') || (typeof value === 'boolean' && value) ? true : false)
  return booleanValue
}

var getLocation = function(href) {
  var linkElement = document.createElement("a");
  linkElement.href = href;
  return linkElement;
};

var inAppBrowserRef
export const showURL = (url, appThemeColor, appThemeFontColor) => {
    var themeColor = HashCodeFromInt(appThemeColor)
    var themeFontColor = HashCodeFromInt(appThemeFontColor)
    let ger = language.get() === 'de'
    let closebuttoncaptionstr = ger ? 'Fertig' : 'Done'
    var target = "_blank";
var options = `location=yes,hidden=yes,clearsessioncache=no,zoom=yes,useWideViewPort=yes,enableViewportScale=yes,presentationstyle=fullscreen',toolbar=yes,usewkwebview=yes,hideurlbar=yes,mediaPlaybackRequiresUserAction=yes,closebuttoncaption=${closebuttoncaptionstr},toolbarcolor=${themeColor},navigationbuttoncolor=${themeFontColor},closebuttoncolor=${themeFontColor}`;


    if (isPhoneGap()) {
      console.log('isPhoneGap')
      var modifiedURL
      if (DeviceInfo.isAndroid) {
        let location = getLocation(url);
        let Checkurl = location.pathname;
        var fileExtension = Checkurl.substring((Checkurl.lastIndexOf('.') + 1)).toLowerCase(); // Convert to lowercase
        var modifiedURL;
        if (url.toLowerCase().endsWith('.pdf')) {
          // Open PDF URLs in InApp Browser
          let options = "location=yes,hidden=no";
          let inAppBrowserRef = cordova.InAppBrowser.open(url, '_blank', options);

          // Listen for the loadstop event to perform actions when the PDF link has loaded
          inAppBrowserRef.addEventListener("loadstop", function(event) {
              // Perform actions specific to handling PDF links
              console.log("PDF link opened:", event.url);
          });
      } else {
          // Open other URLs using InApp Browser
          let options = "location=yes,hidden=no";
          let inAppBrowserRef = cordova.InAppBrowser.open(url, '_blank', options);

          // Listen for the loadstart event to perform actions when the link starts loading
          inAppBrowserRef.addEventListener('loadstart', function(event) {
              // Perform actions specific to loadstart event
              console.log("Link loading started:", event.url);
          });

          // Listen for the loadstop event to perform actions when the link has loaded
          inAppBrowserRef.addEventListener('loadstop', function(event) {
              // Perform actions specific to loadstop event
              console.log("Link loading stopped:", event.url);
          });
      }
        if (fileExtension === 'pdf') {
            modifiedURL = encodeURI(url); // Use the original URL for PDF files

            // Use the cordova-plugin-document-viewer to open the PDF
               // Open PDF URLs in InApp Browser
        inAppBrowserRef = cordova.InAppBrowser.open(modifiedURL, '_blank', options);
        inAppBrowserRef.addEventListener('loadstart', loadStartCallBack);
        inAppBrowserRef.addEventListener('loadstop', loadStopCallBack);
        inAppBrowserRef.show();
        inAppBrowserRef.addEventListener('message', function (params) {
            cordova.plugins.browsertab.openUrl(encodeURI(params.data.href));
        });

        return;
            // cordova.plugins.DocumentViewer.viewDocument(
            //     modifiedURL, // URL to the PDF
            //     'application/pdf', // MIME type
            //     { title: 'PDF Viewer' } // Additional options
            // );

            // downloadUsingWebview(url);
            // return;
        } else {
          modifiedURL = encodeURI(url);

        // Open other URLs using InAppBrowser
        inAppBrowserRef = cordova.InAppBrowser.open(modifiedURL, target, options);
        inAppBrowserRef.addEventListener('loadstart', loadStartCallBack);
        inAppBrowserRef.addEventListener("loadstop", function(event) {
          // Check if the current URL matches the page containing PDF links
          if (event.url === websiteUrl + "/page-with-pdf-links") {
              // Inject JavaScript to handle PDF links
              inAppBrowserRef.executeScript(
                  { code: `
                      // Find all PDF links on the page
                      let pdfLinks = document.querySelectorAll('a[href$=".pdf"]');
                      pdfLinks.forEach(link => {
                          link.addEventListener('click', function(event) {
                              event.preventDefault();
                              // Open PDF link using the InApp Browser
                              cordova.InAppBrowser.open(link.href, '_blank', "location=yes,hidden=no");
                          });
                      });
                  ` }
              );
          }
      });
        inAppBrowserRef.addEventListener('loadstop', loadStopCallBack);
        inAppBrowserRef.show();
        inAppBrowserRef.addEventListener('message', function (params) {
            cordova.plugins.browsertab.openUrl(encodeURI(params.data.href));
        });
        }
    } else {
        // modifiedURL = encodeURI(url)
        // options = `location=no,hardwareback=no,hidden=yes,mediaPlaybackRequiresUserAction=yes,closebuttoncaption=${closebuttoncaptionstr},toolbarcolor=${themeColor},navigationbuttoncolor=${themeFontColor},closebuttoncolor=${themeFontColor},toolbarposition=top,enableViewportScale=yes,hidenavigationbuttons=no`;
        console.log('safari view controller')
        SafariViewController.isAvailable(function (available) {
          if (available) {
            console.log('safari view')
            SafariViewController.show({
                  url: encodeURI(url),
                  hidden: false,
                  animated: false,
                  transition: 'curl',
                  enterReaderModeIfAvailable: false,
                  tintColor: themeFontColor,
                  barColor: themeColor,
                  controlTintColor: themeFontColor
                })
            }
        })
      }
    } else {
      window.open(url, target, options)
    }

  }
  function downloadUsingWebview(pdfUrl) {
    var downloadWebview = cordova.InAppBrowser.open(pdfUrl, '_system');

    // Handle events or callbacks related to the download process
    downloadWebview.addEventListener('loadstart', function(event) {
        // This event is triggered when the download process starts
        console.log("Download started:", event.url);
    });

    downloadWebview.addEventListener('loadstop', function(event) {
        // This event is triggered when the download process finishes
        console.log("Download finished:", event.url);
        // You can perform any necessary actions here, such as displaying a success message
    });

    downloadWebview.addEventListener('exit', function(event) {
        // This event is triggered when the download webview is closed
        console.log("Download webview closed");
        // You can perform any necessary cleanup here
    });
}

// function savePDFToFile(pdfBlob) {
//   window.resolveLocalFileSystemURL(cordova.file.dataDirectory, function (dir) {
//       dir.getFile('downloaded.pdf', { create: true }, function (file) {
//           file.createWriter(function (fileWriter) {
//               fileWriter.write(pdfBlob);
//               console.log("PDF saved successfully.");
//               // Handle further actions, like displaying a success message
//           }, function (error) {
//               console.error("File write error: " + error.code);
//               // Handle the error, e.g., display an error message to the user
//           });
//       });
//   });
// }
export const showExternalURL = (url) => {
  if (DeviceInfo.isIOS) {
    window.location.href= url
  } else {
    var target = "_system";
    window.open(url, target)
  }
}


function loadStartCallBack() {
  // inAppBrowserRef.show();
}

function loadStopCallBack(params) {
  if (inAppBrowserRef != undefined) {
    let code = `
                document.body.onclick = function (e) {
                  var sourceElement = e.srcElement;
                  if (sourceElement.tagName === 'A' || sourceElement.tagName === 'a') {
                    var href = sourceElement.href;
                    if (href) {
                      var linkElement = document.createElement("a");
                      linkElement.href = href;
                      var Checkurl = linkElement.pathname;
                      var fileExtension = Checkurl.substr((Checkurl.lastIndexOf('.') + 1));
                      if (fileExtension && ( fileExtension == 'pdf'|| fileExtension == 'PDF' || fileExtension == 'doc' || fileExtension == 'DOC' || fileExtension == 'docx' || fileExtension == 'DOCX' || fileExtension == 'ppt'|| fileExtension == 'PPT' || fileExtension == 'xls' || fileExtension == 'XLS' || fileExtension == 'csv' || fileExtension == 'CSV')) {
                        var messageObj = { href: href };
                        var stringifiedMessageObj = JSON.stringify(messageObj);
                        webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
                      }
                    }
                  }
                }`;
    inAppBrowserRef.executeScript({ code });
   /* let code = `
                window.inAppBrowserURL = undefined;
                document.body.onclick = function (e) {
                  console.log('document.body.onclick')
                  var sourceElement = e.srcElement;
                  if (sourceElement.tagName === 'A' || sourceElement.tagName === 'a') {
                    console.log(sourceElement.tagName)
                    var href = sourceElement.href;
                    if (href) {
                      console.log('href 1 ', href);
                      var index = href.indexOf('.pdf');
                      if (index !== -1) {
                        console.log('href 2 ', href)
                        window.inAppBrowserURL = href;
                      }
                    }
                  }
                }`
    inAppBrowserRef.executeScript({ code }, function (values) {
      console.log('first script executed.')
      var loop = setInterval(function() {
        inAppBrowserRef.executeScript({ code: "window.inAppBrowserURL" },
          function(values) {
            var inAppBrowserURL = values[0];
            if (inAppBrowserURL) {
              inAppBrowserRef.executeScript({ code: "window.inAppBrowserURL = undefined;" })
              console.log('values', values)
              // clearInterval(loop);
              cordova.plugins.browsertab.openUrl(encodeURI(inAppBrowserURL))
            }
          }
        );
      }, 1000);
    });  */
  }
 }

function loadErrorCallBack(params) {
  // $('#status-message').text("");
  // var scriptErrorMesssage =
  //      "alert('Sorry we cannot open that page. Message from the server is : "
  //      + params.message + "');"
  // inAppBrowserRef.executeScript({ code: scriptError Messsage }, executeScriptCallBack);
  // inAppBrowserRef.close();
  // inAppBrowserRef = undefined;
}

export const loadWebsiteModule = async (SubscriptionModuleId, AppThemeColor, AppThemeFontColor) => {
  loadWebsite(SubscriptionModuleId).then(async (res) => {
    if (res) {
      showURL(res.WebsiteURL, AppThemeColor, AppThemeFontColor)
    }
  }).catch(err => {
    console.log('err', err)
  })
}
export const loadTwitterData = async (SubscriptionModuleId, AppThemeColor, AppThemeFontColor) => {
  console.log('in helper instatwitter')
  loadTwitterData(SubscriptionModuleId).then(async (res) => {
    if (res) {
      console.log('in helper insta res', res)
      showURL(res.twitterId, AppThemeColor, AppThemeFontColor)
    }
  }).catch(err => {
    console.log('err', err)
  })
}

export const loadInstagramModule = async (SubscriptionModuleId, AppThemeColor, AppThemeFontColor) => {
  loadInstagram(SubscriptionModuleId).then(async (res) => {
    if (res) {
      showURL(res.InstagramId, AppThemeColor, AppThemeFontColor)
    }
  }).catch(err => {
    console.log('err', err)
  })
}
export const loadFacebookModule = async (SubscriptionModuleId, AppThemeColor, AppThemeFontColor) => {
  loadFacebook(SubscriptionModuleId).then(async (res) => {
    if (res) {
      showURL(res.FacebookId, AppThemeColor, AppThemeFontColor)
    }
  }).catch(err => {
    console.log('err', err)
  })
}
export const loadYoutubeModule = async (SubscriptionModuleId, AppThemeColor, AppThemeFontColor) => {
  loadYoutubeData(SubscriptionModuleId).then(async (res) => {
    if (res) {
      console.log(res)
      showURL(res.YouTubeChannel, AppThemeColor, AppThemeFontColor)
    }
  }).catch(err => {
    console.log('err', err)
  })
}
export const calculateHeight = (value) => {
  let screenHeight = window.innerHeight
  let Height = 0
  if (value === 'small') {
    Height = screenHeight * (25 / 100)
  } else if (value === 'medium') {
    Height = screenHeight * (40 / 100)
  } else if (value === 'large') {
    Height = screenHeight * (65 / 100)
  } else {
    Height = screenHeight * (50 / 100)
  }
  return Height
}

export const getDeviceCurrencyPattern = () => {
  return new Promise((resolve, reject) => {
    navigator.globalization.getCurrencyPattern('USD', pattern => {
      if (pattern) {
        // console.log('getDeviceCurrencyPattern', pattern)
        resolve(pattern.pattern)
      }
    }, error => {
      reject(error)
    })
  })
}

export const getDeviceDatePattern = () => {
  return new Promise((resolve, reject) => {
    navigator.globalization.getDatePattern(date => {
      if (date) {
        resolve(date.pattern)
      }
    }, error => {
      reject(error)
    }, { formatLength: 'short', selector: 'date and time' })
  })
}

export const getDeviceLocale = () => {
  return new Promise((resolve, reject) => {
    navigator.globalization.getLocaleName(locale => {
      if (locale) {
        resolve(locale.value)
      }
    }, error => {
      reject(error)
    })
  })
}

export const getDeviceLanguage = () => {
  return new Promise((resolve, reject) => {
    navigator.globalization.getPreferredLanguage(language => {
      // console.log('navigator language', language)
      if (language && language.value.includes('-')) {
        // console.log('navigator language.value.split('-')[0]', language.value.split('-')[0])
        resolve(language.value.split('-')[0])
      }
    }, error => {
      reject('de')
    })
  })
}

export const getBrowserCurrencyPattern = async () => {
  let browserCurrencyPattern = ''
  if (isPhoneGap()) {
    browserCurrencyPattern = await getDeviceCurrencyPattern()
  } else {
    // console.log('window.navigator CurrencyPattern', window.navigator)
    browserCurrencyPattern = window.navigator.language || window.navigator.userLanguage
  }
  return browserCurrencyPattern
}

export const getBrowserDatePattern = async () => {
  let browserDatePattern = ''
  if (isPhoneGap()) {
    browserDatePattern = await getDeviceDatePattern()
  } else {
    // console.log('window.navigator DatePattern', window.navigator)
    browserDatePattern = window.navigator.language || window.navigator.userLanguage
  }
  return browserDatePattern
}

export const getBrowserLocale = async () => {
  let browserLocal = ''
  if (isPhoneGap()) {
    browserLocal = await getDeviceLocale()
  } else {
    browserLocal = window.navigator.language || window.navigator.userLanguage
  }
  return browserLocal
}

export const getBrowserLanguage = async () => {
  let browserLanguage = ''
  if (isPhoneGap()) {
    browserLanguage = await getDeviceLanguage()
  } else {
    browserLanguage = window.navigator.language || window.navigator.userLanguage
    if (browserLanguage.includes('-')) {
      browserLanguage = browserLanguage.split('-')[0]
      // console.log('getBrowserLanguage browserLanguage', browserLanguage)
      return browserLanguage
    }
  }
  return browserLanguage
}

const supportedLanguages = ['en', 'de']

const isSupportedLanguage = (language) => {
  return supportedLanguages.includes(language)
}

export const getDefaultOrBrowserLanguage = async (defaultLang = 'de') => {
  let browserLanguage = await getBrowserLanguage()
  let browserLocale = await getBrowserLocale()
  let browserDatePattern = await getBrowserDatePattern()
  let browserCurrencyPattern = await getBrowserCurrencyPattern()
  // console.log('getDefaultOrBrowserLanguage browserLanguage', browserLanguage, browserLocale, browserDatePattern, browserCurrencyPattern)
  // browserLanguage = 'de' // check other languages
  if (isSupportedLanguage(browserLanguage)) {
    return {
      language: browserLanguage,
      locale: browserLocale
    }
  }
  return {
    language: defaultLang,
    locale: browserLocale
  }
  // return {  // un comment when test native db in browser
  //   language: 'en',
  //   locale: 'inr'
  // }
}

export const language = {
  get () {
    return window.localStorage.getItem('language')
  },
  set (language) {
    window.localStorage.setItem('language', language)
  }
}

export const locale = {
  get () {
    return window.localStorage.getItem('locale')
  },
  set (locale) {
    window.localStorage.setItem('locale', locale)
  }
}

export const resource = {
  get () {
    const resource = window.localStorage.getItem('resource')
    return resource ? JSON.parse(resource) : undefined
  },
  set (resource) {
    window.localStorage.setItem('resource', JSON.stringify(resource))
  }
}

export const stopBackgroundActivity = (store) => {
  let storeGetters = store.getters
  if (storeGetters.VideoPlayerArray){
    storeGetters.VideoPlayerArray.forEach((obj)=>{
      obj.player.pause()
    })
  }
//  console.log('stopBackgroundActivity')
}
export const closeSidePanel = (store) => {
  let storeGetters = store.getters
  if (storeGetters.SidePanelActive) {
    storeGetters.panelValue.close()
  }
}
export const getNotifyDeviceId = () => {
  return window.localStorage.getItem('RegistrationId')
}

export const ChannelmsgCount = {
  get () {
    const channelmsgCount = window.localStorage.getItem('channelmsgCount')
    return channelmsgCount ? JSON.parse(channelmsgCount) : []
  },
  set (channelmsgCount) {
    window.localStorage.setItem('channelmsgCount', JSON.stringify(channelmsgCount))
  }
}

export const getChatUserLocalId = (SubscriptionId) => {
  const chatUserId = window.localStorage.getItem('chatUserId'+SubscriptionId)
  return chatUserId ? chatUserId : ''
}

export const removeChatUserLocalId = (SubscriptionId) => {
  window.localStorage.removeItem('chatUserId' + SubscriptionId)
}

export const handleChatNotification = (data) => {
  let channelmsgCount = Helper.ChannelmsgCount.get()
  if (data.additionalData) {
    if(channelmsgCount.length > 0 && channelmsgCount.find(x => x.channelId === data.additionalData.ChannelId)) {
    let clonObj = channelmsgCount.map(x => {
      console.log('if..x...', x, 'data.additionalData.ChannelId', data.additionalData)
      if (x.channelId === data.additionalData.ChannelId) {
        console.log('if..x.count..', x.count)
        x.count = x.count + 1
      }
      return x
    })
    Helper.ChannelmsgCount.set(clonObj)
    } else {
      channelmsgCount.push({'count' : 1, 'channelId': data.additionalData.ChannelId, 'SubscriptionModuleId': data.additionalData.SubscriptionModuleId})
      Helper.ChannelmsgCount.set(channelmsgCount)
    }
  } else {
    if(channelmsgCount.length > 0 && channelmsgCount.find(x => x.channelId === data.ChannelId)) {
      let clonObj = channelmsgCount.map(x => {
        console.log('if..x...', x, 'data.ChannelId', data.additionalData)
        if (x.channelId === data.ChannelId) {
          console.log('if..x.count..', x.count)
          x.count = x.count + 1
        }
        return x
      })
      Helper.ChannelmsgCount.set(clonObj)
    } else {
      channelmsgCount.push({'count' : 1, 'channelId': data.ChannelId, 'SubscriptionModuleId': data.SubscriptionModuleId})
      Helper.ChannelmsgCount.set(channelmsgCount)
    }
  }


}

export const isInViewPort = (element) => {
  var rect = element.getBoundingClientRect()
  var elemTop = rect.top
  var elemBottom = rect.bottom
  return (elemTop > 0) && (elemBottom <= window.innerHeight)
}

export const  handleVideoViewPort = (VideoArray) => {
  var isAutoplay = false
  VideoArray.forEach(videoElement => {
    if(this.isInViewPort(videoElement) && isAutoplay === false) {
      videoElement.play().catch(function(e) {
        //console.log('There was an error in play', e);
      })
      isAutoplay = true
    } else {
        videoElement.pause()
    }
  })
}

export const checkAndMakeLink = (content) => {
  var urlRegex = /(https?:\/\/[^\s]+)/g;
  return content.replace(urlRegex, function(url) {
    return url ? '<a href="' + url + '">' + url + '</a>' : ''
  })
}

export const FormatLongNumberIntoAbbreviator = (a,b) => {
  let value = a
  let formatedValue = 0
  if(value == 0) {
    formatedValue = 0;
  }
  else
  {
    // hundreds
    if(value <= 999){
      formatedValue = value;
    }
    // thousands
    else if(value >= 1000 && value <= 999999){
      console.log(' (value / 1000)',  (value / 1000))
      let val = ((value / 1000) + '')
      formatedValue = val.substring(0, 6) + 'K';
    }
    // millions
    else if(value >= 1000000 && value <= 999999999){
      console.log(' (value / 1000000)',  (value / 1000000))
      let val = ((value / 1000000) + '')
      formatedValue = val.substring(0, 4) + 'M';
    }
    // billions
    else if(value >= 1000000000 && value <= 999999999999){
      console.log(' (value / 1000000000)',  (value / 1000000000))
      let val = ((value / 1000000000) + '')
      formatedValue = val.substring(0, 3) + 'B';
    }
    else
    formatedValue = value;

    return formatedValue
  }
}

export const addStatusBarInHtml = (className) => {
  if (DeviceInfo.isIOS) {
    let context = document.html || document.getElementsByTagName('html')[0]
    context.classList.add(className)
  }
}

export const showPopupAtCenter = (popupElm) => {
  popupElm.style.top = ((window.innerHeight/2) - (popupElm.offsetHeight/2))+'px'
  popupElm.style.left = ((window.innerWidth/2) - (popupElm.offsetWidth/2))+'px'
}

// User Profile Edit and Registration chat module
export const getPictureReg = (source, thisVal) => {
  var that = thisVal
  var pictureSource = navigator.camera.PictureSourceType
  navigator.camera.getPicture(onSuccess, onFail, {
    quality: 50,
    allowEdit: true,
    correctOrientation: true,
    sourceType: source === 'PHOTOLIBRARY' ? pictureSource.PHOTOLIBRARY: pictureSource.CAMERA,
    destinationType: Camera.DestinationType.FILE_URI
  })
  async function onSuccess(imageURI) {
    let url = imageURI
    // if (DeviceInfo.isIOS) {
    //   url = window.Ionic.WebView.convertFileSrc(url)
    // }
    getBase64forReg(url, that)
  }
  function onFail(message) {
   console.log(that.resource.failedCptn + message);
  }
}
export const getBase64forReg = (Url, thisVal) => {
  var image = new Image()
  var that = thisVal
  image.src = Url;
  image.onload = function () {
      var canvas = document.createElement("canvas");
      canvas.width = this.width;
      canvas.height = this.height;
      that.imgHeight = this.height;
      that.imgWeight = this.width;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(this, 0, 0, that.imgWeight, that.imgHeight);
      that.dataURL = canvas.toDataURL("image/jpeg");
      that.getStyle(that.dataURL)
      that.uploadedbase64 = that.dataURL.replace(/^data:image\/[a-z]+;base64,/, "");
      return that.dataURL;
  }
}

export const getPicture = (source, thisVal) => {
  var that = thisVal
  var pictureSource = navigator.camera.PictureSourceType
  navigator.camera.getPicture(onSuccess, onFail, {
    quality: 85,
    allowEdit: true,
    correctOrientation: true,
    sourceType: source === 'PHOTOLIBRARY' ? pictureSource.PHOTOLIBRARY: pictureSource.CAMERA,
    destinationType: Camera.DestinationType.FILE_URI
  })
  async function onSuccess(imageURI) {
    let url = imageURI
    // if (DeviceInfo.isIOS) {
    //   url = window.Ionic.WebView.convertFileSrc(url)
    // }
    getBase64fromImageUrl(url, that)
  }
  function onFail(message) {
   console.log(that.resource.failedCptn + message);
  }
}
export const getBase64fromImageUrl = (Url, thisVal) => {
  var image = new Image()
  var that = thisVal
  image.src = Url;
  that.attachdisable = true
  image.onload = function () {
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0);
      var MAX_WIDTH = 1920;
      var MAX_HEIGHT = 1920;
      var width = image.width;
      var height = image.height;
      if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
      } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
      }
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(this, 0, 0, width, height);
      that.dataURL = canvas.toDataURL("image/jpeg", 0.5);
      // that.getStyle(that.dataURL)
      let imgpayload = { "ImageBase64Data": "", "Extension": "" }
      imgpayload.Extension =  that.dataURL.split(';')[0].split('/')[1]
      imgpayload.ImageBase64Data = that.dataURL.replace(/^data:image\/[a-z]+;base64,/, "");
      that.attachments.unshift(that.dataURL)
      that.uploadedbase64.unshift(imgpayload);
      that.attachdisable = false
      return that.dataURL;
  }
}
export const getPictureFromMedia = (thisVal) => {
  var that = thisVal
  var args = {
    'selectMode': 100, //101=picker image and video , 100=image , 102=video
    'maxSelectCount': 15, //default 40 (Optional)
    'maxSelectSize': 188743680, //188743680=180M (Optional) only android
  }
  MediaPicker.getMedias(args, function(medias) {
    getThumbnail(medias, that)
  })
}
function getThumbnail(medias, thisVal) {
  for (var i = 0; i < medias.length; i++) {
    let compressUrl = ''
    compressUrl = medias[i].uri
    // if (DeviceInfo.isIOS) {
    //   compressUrl = window.Ionic.WebView.convertFileSrc(medias[i].uri)
    // } else {
    //   compressUrl = medias[i].uri
    // }
    let mediaType = compressUrl.substring(compressUrl.lastIndexOf('.')+1, compressUrl.length) || ''
    if (mediaType.toLowerCase() ==='gif') {
      getBase64FromImage(compressUrl, thisVal)
    } else {
      getBase64fromImageUrl(compressUrl, thisVal)
    }
  }
}
function getBase64FromImage(mediaUrl, thisVal, onSuccess, onError) {
  var xhr = new XMLHttpRequest();
  let that = thisVal
  that.attachdisable = true
  xhr.responseType = "arraybuffer";
  xhr.open("GET", mediaUrl, true);
  xhr.onload = function () {
      var base64, binary, bytes, mediaType;
      bytes = new Uint8Array(xhr.response);
      //NOTE String.fromCharCode.apply(String, ...
      //may cause "Maximum call stack size exceeded"
      binary = [].map.call(bytes, function (byte) {
          return String.fromCharCode(byte);
      }).join('');
      mediaType = mediaUrl.substring(mediaUrl.lastIndexOf('.')+1, mediaUrl.length) || ''
      let b2a =  btoa(binary)
      base64 = [
          'data:image/',
          mediaType ? mediaType + ';':'',
          'base64,',
          b2a
      ].join('');
      onSuccess(base64, b2a);
  };
  async function onSuccess(imageURI, b2a) {
    let imgpayload = { "ImageBase64Data": "", "Extension": "" }
    imgpayload.Extension =  imageURI.split(';')[0].split('/')[1]
    imgpayload.ImageBase64Data = b2a;
    that.uploadedbase64.unshift(imgpayload);
    that.attachments.unshift(imageURI)
    that.attachdisable = false
  }
  xhr.onerror = onError;
  xhr.send();
}
export const chunkArray = (myArray, chunk_size) => {
  var index = 0;
  var arrayLength = myArray.length;
  var tempArray = [];

  for (index = 0; index < arrayLength; index += chunk_size) {
      let myChunk = myArray.slice(index, index+chunk_size);
      // Do something if you want with the group
      tempArray.push(myChunk);
  }
  return tempArray
}
export const UploadFilestoServer = async (FileData, thisVal, onSuccess, onError) => {
  let uploadResponse = await Post(`${thisVal.AppConfig.Urls.WebAPIURL}/api/ModuleCustomCodeAuth/UploadFileData`, FileData)
  return uploadResponse
}
export const RemoveFilesfrmServer = async (payload, thisVal, onSuccess, onError) => {
  let uploadResponse = await Post(`${thisVal.AppConfig.Urls.WebAPIURL}/api/ModuleCustomCodeAuth/DeleteUploadedFile`, payload)
  return uploadResponse
}
export const validatefileupload = async (fileName, filetypes, onSuccess, onError) => {
  console.log('validatefileupload55', fileName, filetypes)
    var file_extension = fileName.split('.').pop().toLowerCase()
    let  found = false
      for(var i = 0; i <= filetypes.length; i++)
      {
        console.log('in for', filetypes[i].split('/')[1], file_extension)
        if(filetypes[i].split('/')[1] === file_extension)
        {
          console.log('in true')
          found = true
          return true; // valid file extension
        }
        if (found === true) { break; }
      }
      console.log('in false')
      return false;
}



// WEBPACK FOOTER //
// ./src/modules/helper/index.js